import { useState, useEffect } from 'react';

import { useQueryClient, MutationKey } from '@tanstack/react-query';

import { MutationStatus } from 'models/enums';

const useMutationStatus = (mutationKey: string | MutationKey) => {
    const [mutationStatus, setMutationStatus] = useState(MutationStatus.IDLE);
    const queryClient = useQueryClient();
    const mutationCache = queryClient.getMutationCache();

    const unsubscribe = mutationCache.subscribe((event) => {
        if (event?.mutation?.options.mutationKey === mutationKey) {
            setMutationStatus(event.mutation.state.status as MutationStatus);
        }
    });

    useEffect(
        () => () => {
            unsubscribe();
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return mutationStatus;
};

export default useMutationStatus;
